import axiosInstance from "../../api/axiosInstance";

export const fetchTimelineSetByTournamentIdAPI = async (tournamentId) => {
  const timelineSet = await axiosInstance.get(
    `timelines/get-timeline-by-tournamentId/${tournamentId}`
  );

  return timelineSet.data;
};
